__turbopack_context__.v({
  "main": "LTwoColsRight-module__DhUYWa__main",
  "root": "LTwoColsRight-module__DhUYWa__root",
  "sidebar": "LTwoColsRight-module__DhUYWa__sidebar",
});
